// *********************************************************
// Copyright (c) 2017 Agra Technologies Pvt. Ltd.. All rights reserved
// *********************************************************
import { Injectable, EventEmitter } from '@angular/core';

/**
 * A service to fire events, used to communicate between modules
 */
@Injectable({providedIn: "root"})
export class MoneytorEventsService {

  public commentAdded = new EventEmitter();
  public phoneCallLogged = new EventEmitter();
  public emailSent = new EventEmitter();
  public smsSent = new EventEmitter();
  public paymentDone = new  EventEmitter();
  public changeTask = new EventEmitter();
  public sideNav = new  EventEmitter();
  public confirmTask = new EventEmitter();
  public previewEvent = new EventEmitter();
  public addNewAddress = new EventEmitter();
  public currentPhoneDeleted = new EventEmitter();
  public currentEmailDeleted = new EventEmitter();
  public paymentUpdated = new EventEmitter();
  public closeOffer = new EventEmitter();
  public openPhoneModal = new EventEmitter();
  public closeAll = new EventEmitter();
}
